<template>
  <div>
    <div class="progress-val-wrap">
      <div class="val1 fw-600">{{completePercent}}</div>
      <div class="val2">{{event.stock && event.stock.initialStock}} Tickets</div>
    </div>

    <div class="progress progress-lg">
      <div class="value" v-bind:style="{ width: completePercent}"></div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'EventProgress',
    props: ['event'],
    computed: {
      completePercent() {
        let remainingStock = (this.event.stock && this.event.stock.remainingStock) || 0;
        let initialStock = (this.event.stock && this.event.stock.initialStock) || 0;
        let percentile = Math.round((1-parseFloat(remainingStock) / parseFloat(initialStock)) * 100) + '%';
        return isNaN(percentile) ? '0%' : percentile;
      }
    }
  };
</script>
